import React, { useEffect } from 'react';
import { DataTable } from '../../Table/Table.jsx';
import { Footer } from '../../Footer/Footer.jsx';
import { CustomDialog } from '../../messages/CustomDialog.jsx';
import '../../../App.css'
import { successMessages, confirmationMessages } from '../../messages/commonMessages.jsx';
import Tooltip from '@mui/material/Tooltip';
import { AlertDialog } from '../../messages/AlertDialog.jsx'
import { Formulario } from './Formulario/Formulario.jsx';
import { useParametros } from './useParametros.js';


const MantenimientoParametro = () => {
    const { handleRowSelectionChange, getParametros, data, handleCloseDialog, columnas,
        isDialogOpen, isEdit, isView, isAdd, handleAdd, handleCancel,
        isDelete, selectedRow,
        handleSave } = useParametros();
    const handleGenerateReport = () => {
        alert(successMessages.DOWNLOAD_SUCCESSFUL);
    };
    useEffect(() => {
        getParametros();
    }, []);
    return (
        <div className='content-wrapper'>
            <div className="wrapper-card">
                <h1>
                    Mantenimiento de Parámetros
                </h1>
                <div className='form-container'>
                    <div className="content">
                        <div className='form-container'>
                            <div className="title">
                                Lista de Parámetros
                            </div>
                            <div className="content">
                                <DataTable
                                    data={data && Array.isArray(data) ? data.map(row => ({ id: row.idParametro, ...row })) : []}
                                    columns={columnas}
                                    onRowSelectionChange={handleRowSelectionChange} >
                                    {data === null && (
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            Cargando datos...
                                        </div>
                                    )}
                                </DataTable>
                                <div className='button-action'>
                                    <Tooltip title="Agregar">
                                        <button id='btn-agregar-dialog' className="action-button" onClick={handleAdd}>Agregar</button>
                                    </Tooltip>
                                    {isDialogOpen && isAdd && (
                                        <CustomDialog
                                            question={'Agregar Parámetro'}
                                            message={<Formulario onSave={handleSave} onCancel={handleCancel} parametro={selectedRow} render={'Add'} />}
                                            onClose={handleCloseDialog}
                                        />
                                    )}
                                    {isDialogOpen && isEdit && (
                                        <CustomDialog
                                            question={'Modificar Párametro'}
                                            message={<Formulario onSave={handleSave} onCancel={handleCancel} parametro={selectedRow} render={'Edit'} />}
                                            onClose={handleCloseDialog}
                                        />
                                    )}
                                    {isDialogOpen && isView && (
                                        <CustomDialog
                                            question={'Consultar Parámetro'}
                                            message={<Formulario onSave={handleSave} onCancel={handleCancel} parametro={selectedRow} render={'View'} />}
                                            onClose={handleCloseDialog}
                                        />
                                    )}
                                    {isDialogOpen && isDelete && (
                                        <AlertDialog
                                            question={'Eliminar Parámetro'}
                                            message={confirmationMessages.DELETE_CONFIRMATION_PARAMETRO}
                                            isOpen={isDialogOpen}
                                            onClose={handleCancel}
                                            onAccept={handleCancel}
                                            onCancel={handleCancel}
                                        />
                                    )}
                                    <Tooltip title="Generar Reporte">
                                        <button id='btn-generar-reporte' className="action-button" onClick={handleGenerateReport}>Generar Reporte</button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export { MantenimientoParametro };